import { createApiEffect } from '@/features/api/common/create-api-effect'
import { GetListQueryParams, TableDataResponse } from '@/features/api/types'
import { Courses } from '@/features/api/learning/types'

export const getCoursesListFx = createApiEffect<GetListQueryParams, TableDataResponse<Courses[]>>({
  requestMapper: (query) => ({
    method: 'GET',
    url: '/api/course-app/courses/list/',
    query,
  }),
})
